import { CoverageLevel, ErrorLevel, PAHNotified, PolicyStatus, PolicyFilters } from "./Types";
import { FieldConfig } from "../../utils/GenericFilters";
import { FieldTypes } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

/**
 *
 */
export const ErrorLevelDisplay: Readonly<Record<ErrorLevel, string>> = {
    [ErrorLevel.CRITICAL]: "Critical",
    [ErrorLevel.WARNING]: "Warning",
};

/**
 *
 */
export const CoverageLevelDisplay: Readonly<Record<CoverageLevel, string>> = {
    [CoverageLevel.FULL_FUNCTION]: "Full Functional",
    [CoverageLevel.THREE_COMPONENTS]: "Three Components",
};

/**
 *
 */
export const PAHNotifiedDisplay: Readonly<Record<PAHNotified, string>> = {
    [PAHNotified.TRUE]: "Yes",
    [PAHNotified.FALSE]: "No",
};

/**
 *
 */
export const PolicyStatusDisplay: Readonly<Record<PolicyStatus, string>> = {
    [PolicyStatus.APPROVED]: "Active",
    [PolicyStatus.CANCELED]: "Canceled",
    [PolicyStatus.ERROR]: "Error",
    [PolicyStatus.RECEIVED]: "Received",
    [PolicyStatus.EXPIRED]: "Expired",
    [PolicyStatus.DUPLICATED]: "Duplicated",
};

/**
 * Options for Policy status filter
 */
export const PolicyStatusOptions = Object.keys(PolicyStatus).map(status => ({
    label: PolicyStatusDisplay[status as PolicyStatus],
    value: status,
}));

/**
 * Unified field configuration for Policy filters
 * Everything in one place - labels, types, and field-specific options!
 */
export const PolicyFilterFieldsConfig: Record<keyof PolicyFilters, FieldConfig> = {
    policyNumber: {
        label: "Policy number",
        type: FieldTypes.Text,
    },
    licensePlate: {
        label: "License plate",
        type: FieldTypes.LicensePlate,
    },
    partnerNumber: {
        label: "Policy holder number",
        type: FieldTypes.Number,
    },
    partnerName: {
        label: "Policy holder name",
        type: FieldTypes.Text,
    },
    productNumber: {
        label: "Product number",
        type: FieldTypes.Number,
    },
    chassisNumber: {
        label: "Chassis number",
        type: FieldTypes.Text,
    },
    policyStatus: {
        label: "Status",
        type: FieldTypes.Select,
        options: PolicyStatusOptions,
        placeholder: "Make a choice",
    },
};
